import { render, staticRenderFns } from "./GaugesChartNormal.vue?vue&type=template&id=9522b008&"
import script from "./GaugesChartNormal.vue?vue&type=script&lang=ts&"
export * from "./GaugesChartNormal.vue?vue&type=script&lang=ts&"
import style0 from "./GaugesChartNormal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardActions,VCardText})
